import type { RequestResponse } from '@/types/publicType'
import type { clientInitInterface } from '@/types/apiType/publicTyps'

/**
 * 获取
 */
export function apiGetClientInit(): Promise<
  RequestResponse<clientInitInterface>
> {
  return getFetchData({
    url: '/client/init',
    method: 'GET'
  })
}
